import styled from 'styled-components';

import { Button, CheckBox, Flex } from '@sine/sine-ui-components';

interface EmailNotificationControlProps {
  canSendEmail: boolean;
  emailCount: number;
  totalCount: number;
  onToggle: VoidFunction;
  disabled: boolean;
  isEditing: boolean;
  onAddInvitee?: VoidFunction;
}

const StyledCheckBox = styled(CheckBox)`
  margin-top: 0;
`;

export function EmailNotificationControl({
  canSendEmail,
  emailCount,
  totalCount,
  onToggle,
  disabled,
  isEditing,
  onAddInvitee,
}: EmailNotificationControlProps) {
  const message = isEditing ? 'Re-send invitation to guest when saving' : 'Notify guest/s with an email invitation';
  const guestLabel = isEditing ? 'guest' : 'guest/s';

  return (
    <Flex alignItems='center'>
      <Flex grow={1}>
        <StyledCheckBox
          label={
            <>
              {message}{' '}
              <b>
                ({emailCount} of {totalCount} {guestLabel})
              </b>
            </>
          }
          data-st-ext='checkbox-send-emails'
          value={canSendEmail}
          onClick={onToggle}
          disabled={disabled}
          noSpaceReservation
        />
      </Flex>
      <Flex grow={0}>
        {!isEditing && onAddInvitee && (
          <Button variant='tertiary' icon='add' onClick={onAddInvitee} data-st-ext='button-add-another-invitee'>
            Add another invitee
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
